import ButtonIcon from '@tmh-website/ui/ButtonIcon';
import ButtonOutlined from '@tmh-website/ui/ButtonOutlined';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
`;

interface HeaderButton {
  $hideOnMobile: boolean;
}

export const AdjustedButtonOutlined = styled(ButtonOutlined)<HeaderButton>`
  margin-left: ${props => props.theme.gap.xSmall};
  ${props =>
    props.$hideOnMobile &&
    `@media (max-width: 529px) {
        display: none;
      }
    `};
`;

export const AccountButton = styled(ButtonIcon)<HeaderButton>`
  ${props =>
    props.$hideOnMobile &&
    `
      @media (max-width: 418px) {
        display: none;
      }
    `};
`;

export const WishlistButton = styled(ButtonIcon)<HeaderButton>`
  ${props =>
    props.$hideOnMobile &&
    `
      @media (max-width: 462px) {
        display: none;
      }
    `};
`;

export const CartButton = styled(ButtonIcon)<HeaderButton>`
  ${props =>
    props.$hideOnMobile &&
    `
      @media (max-width: 374px) {
        display: none;
      }
    `};
`;
